export let GridSidebarValue = /*#__PURE__*/function (GridSidebarValue) {
  GridSidebarValue["Pivot"] = "pivot";
  GridSidebarValue["Charts"] = "charts";
  return GridSidebarValue;
}({});